import Axios, { AxiosRequestConfig } from 'axios';
import { acquireAccessToken } from 'services/tokenService';
import { env } from 'config/env';

const businessServiceAxios = Axios.create({
  baseURL: env.VITE_APP_BUSINESS_SERVICE_BASE_URL
});

businessServiceAxios.interceptors.request.use(async (config) => {
  const accessToken = await acquireAccessToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  } else if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

type BusinessServiceRequestConfig = RequestInit & {
  responseType?: AxiosRequestConfig['responseType'];
};

export const businessServiceClient = <T>(url: string, config?: BusinessServiceRequestConfig): Promise<T> => {
  const isFormData = config?.body instanceof FormData;

  return businessServiceAxios({
    url,
    method: config?.method,
    data: config?.body,
    headers: isFormData ? undefined : (config?.headers as AxiosRequestConfig['headers']),
    signal: config?.signal as AxiosRequestConfig['signal'],
    responseType: config?.responseType
  }).then(({ data, status }) => ({ data, status }) as unknown as T);
};

export default businessServiceClient;
